import {
  SimpleShowLayout,
  Show,
  TextField,
  ReferenceArrayField,
  SingleFieldList,
  ReferenceField,
  ChipField,
  BooleanField,
  NumberField,
  FunctionField,
  Labeled,
  EditButton,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import {} from "utils/constants";
import BackButtonToolbar from "features/BackButtonToolbar";
import { documentRequests } from "api/documentsApi";
import { administrationRequests } from "api/administrationApi";
import { SpecialityStatusChoices } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { SectionTitle } from "features/SectionTitle";

const ShowSpecialities = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за специалност"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canUpdateSpecialities}>
              <EditButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Професионална квалификация (BG)">
              <TextField
                source="professionalQualification.nameBg"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Професионална квалификация (EN)">
              <TextField
                source="professionalQualification.nameEn"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Минимален бал за прием">
              <NumberField source="minimalScoreForEntry" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Структурна единица">
              <ReferenceField
                source="structuralUnitId"
                reference={administrationRequests.getStructuralUnitsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Професионално направление">
              <ReferenceField
                source="professionalDirectionId"
                reference={administrationRequests.getProfessionalDirectionsSelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Тип обучение">
              <ReferenceArrayField
                source="studyTypeIds"
                reference={administrationRequests.getStudyTypesSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField
                    source="name"
                    size="small"
                  />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Статус">
              <FunctionField render={record => SpecialityStatusChoices[record.status - 1]?.name} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Предлага се за чужденци">
              <BooleanField source="isOfferedToForeigners" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Полово разпределение на местата">
              <BooleanField source="isDistributedByGender" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Класиране само по първо желание">
              <BooleanField source="firstChoiceRankingOnly" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Защитена специалност">
              <BooleanField source={"isProtected"} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Задължителен избор на чужд език">
              <BooleanField source={"canPickForeignLanguage "} />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Типове прием"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Типове прием">
              <ReferenceArrayField
                source="receptionTypesIds"
                reference={administrationRequests.getReceptionTypesSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Изпити"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Изпити">
              <ReferenceArrayField
                source="examsIds"
                reference={administrationRequests.getExamsSelect()}
              >
                <SingleFieldList linkType={false}>
                  {/* Exam names are long; MUI chips don't wrap by default and overflow the box on mobile. */}
                  <ChipField
                    source="name"
                    sx={{
                      height: "auto",
                      maxWidth: "100%",
                      py: 0.5,
                      "& .MuiChip-label": { whiteSpace: "normal" },
                    }}
                  />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Език на преподаване"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Език на преподаване">
              <ReferenceArrayField
                source="instructionLanguageIds"
                reference={administrationRequests.getInstructionLanguagesSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Декларации"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Декларации">
              <ReferenceArrayField
                source="declarationIds"
                reference={documentRequests.getDeclarationsSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Специфични изисквания"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Специфични изисквания">
              <ReferenceArrayField
                source="specificRequirementIds"
                reference={administrationRequests.getSpecificRequirementsSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowSpecialities;
